"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseObligation = exports.isObligation = exports.OBLIGATION_SIZE = exports.ObligationLayout = exports.ObligationLiquidityLayout = exports.ObligationCollateralLayout = void 0;
const buffer_layout_1 = require("buffer-layout");
const util_1 = require("../util");
const lastUpdate_1 = require("./lastUpdate");
/** @internal */
exports.ObligationCollateralLayout = (0, buffer_layout_1.struct)([
    (0, util_1.publicKey)('depositReserve'),
    (0, util_1.u64)('depositedAmount'),
    (0, util_1.decimal)('marketValue'),
    (0, util_1.u256)('padding'),
], 'collateral');
/** @internal */
exports.ObligationLiquidityLayout = (0, buffer_layout_1.struct)([
    (0, util_1.publicKey)('borrowReserve'),
    (0, util_1.decimal)('cumulativeBorrowRateWads'),
    (0, util_1.decimal)('borrowedAmountWads'),
    (0, util_1.decimal)('marketValue'),
    (0, util_1.u256)('padding'),
], 'liquidity');
/** @internal */
exports.ObligationLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)('version'),
    lastUpdate_1.LastUpdateLayout,
    (0, util_1.publicKey)('lendingMarket'),
    (0, util_1.publicKey)('owner'),
    (0, util_1.decimal)('depositedValue'),
    (0, util_1.decimal)('borrowedValue'),
    (0, util_1.decimal)('allowedBorrowValue'),
    (0, util_1.decimal)('unhealthyBorrowValue'),
    (0, util_1.u512)('padding'),
    (0, buffer_layout_1.u8)('depositsLen'),
    (0, buffer_layout_1.u8)('borrowsLen'),
    (0, buffer_layout_1.blob)(exports.ObligationCollateralLayout.span + 9 * exports.ObligationLiquidityLayout.span, 'dataFlat'),
], 'obligation');
exports.OBLIGATION_SIZE = exports.ObligationLayout.span;
const isObligation = (info) => {
    return info.data.length === exports.OBLIGATION_SIZE;
};
exports.isObligation = isObligation;
const parseObligation = (pubkey, info) => {
    if (!(0, exports.isObligation)(info))
        return;
    const buffer = Buffer.from(info.data);
    const { version, lastUpdate, lendingMarket, owner, depositedValue, borrowedValue, allowedBorrowValue, unhealthyBorrowValue, padding, depositsLen, borrowsLen, dataFlat, } = exports.ObligationLayout.decode(buffer);
    if (!version)
        return;
    const depositsSpan = depositsLen * exports.ObligationCollateralLayout.span;
    const borrowsSpan = borrowsLen * exports.ObligationLiquidityLayout.span;
    const depositsBuffer = dataFlat.slice(0, depositsSpan);
    const deposits = (0, buffer_layout_1.seq)(exports.ObligationCollateralLayout, depositsLen).decode(depositsBuffer);
    const borrowsBuffer = dataFlat.slice(depositsSpan, depositsSpan + borrowsSpan);
    const borrows = (0, buffer_layout_1.seq)(exports.ObligationLiquidityLayout, borrowsLen).decode(borrowsBuffer);
    const obligation = {
        version,
        lastUpdate,
        lendingMarket,
        owner,
        depositedValue,
        borrowedValue,
        allowedBorrowValue,
        unhealthyBorrowValue,
        deposits,
        borrows,
    };
    return {
        pubkey,
        info,
        data: obligation,
    };
};
exports.parseObligation = parseObligation;
